import axios from 'axios';

const BASE_URL = 'https://servicodados.ibge.gov.br/api/v1';

const IbgeService = {
    byState: async function (state) {
        try {
            const response = await axios.get(`${BASE_URL}/localidades/estados/${state}/municipios`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default IbgeService;

export { IbgeService };

